import React from "react";
import { formatDateTime } from "@/lib/utils-app";

const DOT_COLOR = {
  beslut: "border-emerald-600 bg-emerald-50",
  komplettering: "border-amber-600 bg-amber-50",
  avslutat: "border-zinc-500 bg-zinc-100",
};

/** Vertikal tidslinje över ärendets historik (senaste först). */
export default function CaseTimeline({ events = [] }) {
  return (
    <div className="bg-white border border-zinc-200 rounded-sm p-6">
      <h3 className="text-lg font-medium" style={{ fontFamily: "Outfit" }}>Tidslinje</h3>
      <ol className="mt-6 space-y-5" data-testid="timeline">
        {events.slice().reverse().map((t) => (
          <li key={`${t.at}-${t.status}`} className="relative pl-6">
            <span className={`absolute left-0 top-1.5 w-3 h-3 rounded-full border-2 ${
              DOT_COLOR[t.status] || "border-blue-700 bg-blue-50"
            }`} />
            <div className="text-xs text-zinc-500">{formatDateTime(t.at)}</div>
            <div className="text-sm font-medium text-zinc-900 mt-0.5">{t.note}</div>
            <div className="text-xs text-zinc-500">av {t.by}</div>
          </li>
        ))}
      </ol>
    </div>
  );
}
